import { RideStatusEnum } from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  greenMui,
  lightBlueMui,
  orangeMui,
  redMui,
  rydeColors,
  tealMui,
} from "@ryde/theme";

export interface IRideStatusIndicatorControl {
  $bgColor: string;
  $leftColor: string;
  color: string;
  $translateKey: string;
  $dataE2eValue?: string;
  fontSize?: string;
}

export interface IRideStatusIndicator {
  status: RideStatusEnum | null | undefined;
  fontSize?: string;
}

export const RideStatusIndicatorConst: Record<
  RideStatusEnum,
  IRideStatusIndicatorControl
> = {
  [RideStatusEnum.Approved]: {
    $bgColor: rydeColors.greenishTeal,
    $leftColor: rydeColors.thujaGreen,
    color: rydeColors.white,
    $translateKey: "Approved",
    $dataE2eValue: "Approved",
  },
  [RideStatusEnum.Canceled]: {
    $bgColor: redMui.A200,
    $leftColor: rydeColors.crisisRed,
    color: rydeColors.white,
    $translateKey: "Canceled",
    $dataE2eValue: "Canceled",
  },
  [RideStatusEnum.Done]: {
    $bgColor: blueGreyMui._50,
    $leftColor: blueGreyMui._300,
    color: rydeColors.black,
    $translateKey: "Done",
    $dataE2eValue: "Done",
  },
  [RideStatusEnum.DoneApproved]: {
    $bgColor: greenMui._50,
    $leftColor: greenMui._600,
    color: rydeColors.black,
    $translateKey: "Done_Approved",
    $dataE2eValue: "Done approved",
  },
  [RideStatusEnum.Draft]: {
    $bgColor: rydeColors.princetonOrange,
    $leftColor: rydeColors.mochaccino,
    color: rydeColors.white,
    $translateKey: "Draft",
    $dataE2eValue: "Draft",
  },
  [RideStatusEnum.OnRoute]: {
    $bgColor: rydeColors.neonBoneyard,
    $leftColor: rydeColors.venetianNights,
    color: rydeColors.black,
    $translateKey: "On_Route",
    $dataE2eValue: "On route",
  },
  [RideStatusEnum.New]: {
    $bgColor: lightBlueMui._50,
    $leftColor: lightBlueMui._700,
    color: rydeColors.black,
    $translateKey: "New",
    $dataE2eValue: "New",
  },
  [RideStatusEnum.Received]: {
    $bgColor: tealMui._50,
    $leftColor: tealMui._300,
    color: rydeColors.black,
    $translateKey: "Received",
    $dataE2eValue: "Received",
  },
  [RideStatusEnum.Rejected]: {
    $bgColor: rydeColors.goryRed,
    $leftColor: rydeColors.redBlood,
    color: rydeColors.white,
    $translateKey: "Rejected",
    $dataE2eValue: "Rejected",
  },
  [RideStatusEnum.Sent]: {
    $bgColor: deepPurpleMui._50,
    $leftColor: rydeColors.iridescentPurple,
    color: rydeColors.black,
    $translateKey: "Sent",
    $dataE2eValue: "Sent",
  },
  [RideStatusEnum.Sending]: {
    $bgColor: deepPurpleMui._50,
    $leftColor: rydeColors.iridescentPurple,
    color: rydeColors.black,
    $translateKey: "Sending",
    $dataE2eValue: "Sending",
  },
  [RideStatusEnum.Declined]: {
    $bgColor: orangeMui._50,
    $leftColor: orangeMui._900,
    color: rydeColors.black,
    $translateKey: "Declined",
    $dataE2eValue: "Declined",
  },
};
